import * as React from 'react';
import { NavLink } from 'reactstrap';
import { FaEnvelope } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { FaPinterest } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaGraduationCap } from 'react-icons/fa';
import { IoLocationSharp } from 'react-icons/io5';

import './Home.css';

import { useEffect } from 'react';

const contentImages = require.context('../../assets/images/content', true);

export const Home = () => {
  const matches = window.matchMedia('(min-width: 768px)').matches;
  const [isPhone, setIsPhone] = React.useState(matches);

  useEffect(() => {
    const handler = (e) => setIsPhone(e.matches);
    window.matchMedia('(min-width: 768px)').addEventListener('change', handler);
  }, [isPhone]);

  return (
    <>
      <section className="hero-container">
        <video autoPlay loop muted playsInline className="hero-bg">
          <source src={contentImages(`./home/demo.mp4`)} type="video/mp4" />
          Tu navegador no soporta video HTML5.
        </video>
      </section>
      <div className="home_content">
        <section className="about-me">
          <div className="about-me_container">
            <div className="about-me_text">
              <h2 className="about-me_title">
                Soy Pedro Gavilán, fotógrafo y editor audiovisual
              </h2>

              <p>
                Mi pasión por lo audiovisual nace del cine. Desde pequeño me
                fascinaba ver películas, pero lo que realmente despertó mi
                vocación fue descubrir los making of, donde se revela todo el
                proceso creativo detrás de cámaras: desde la grabación hasta los
                efectos visuales y el color grading. Esa curiosidad me llevó a
                investigar, formarme y experimentar por mi cuenta.
              </p>

              <p>
                Comencé con la fotografía, aprendiendo de forma autodidacta con
                mi primera cámara. Ahí descubrí el mundo de la composición, la
                iluminación, el retoque y el tratamiento del color. Más tarde
                decidí profesionalizarme y cursé el Curso de Postproducción de
                Cine y TV en MasterD, donde dominé el workflow completo con
                DaVinci Resolve Studio: edición, composición con Fusion,
                corrección de color, mezcla de audio y entrega final.
              </p>

              <p>
                Actualmente me encuentro profundizando mis conocimientos en
                composición digital y color con un máster en Animum Advanced
                School, tras haber finalizado el curso de Fundamentos de la
                Producción 3D, donde trabajé todo el pipeline: desde la
                recepción del concept art hasta el render y la composición
                final.
              </p>
            </div>
            <div className="about-me_image">
              <img
                src={contentImages(`./home/home-image.jpg`)}
                alt="Pedro Gavilán retrato"
              />
            </div>
          </div>
        </section>

        <section className="projects">
          <h3 className="projects_sub_title">Mi trabajo</h3>
          <h2 className="projects_title">Proyectos destacados</h2>

          <div className="projects_content">
            <div className="project_item">
              <div className="project_item-image">
                <img
                  src={contentImages(`./projects/03.jpg`)}
                  alt="3D y Mothion Graphics"
                />
              </div>
              <div className="project_item_content">
                <h3 className="project_item_title">3D y Mothion Graphics</h3>
                <p>
                  Videopromoción de Coca-Cola (proyecto personal no remunerado):
                  modelado 3D, texturizado, simulación de líquidos y particulas,
                  iluminación y render final realizado en Blender.
                </p>
              </div>
            </div>

            <div className="project_item">
              <div className="project_item-image">
                <img
                  src={contentImages(`./projects/04.jpg`)}
                  alt="Proyecto final animum"
                />
              </div>
              <div className="project_item_content">
                <h3 className="project_item_title">Proyecto final animum</h3>
                <p>
                  Proyecto final en Animum: modelado completo de una casa y
                  composición final con todos los procesos.
                </p>
              </div>
            </div>

            <div className="project_item">
              <div className="project_item-image">
                <img
                  src={contentImages(`./projects/01.jpg`)}
                  alt="Color Correction"
                />
              </div>
              <div className="project_item_content">
                <h3 className="project_item_title">Color Correction</h3>
                <p>
                  Varios proyectos personales donde exploro el color a nivel
                  narrativo, usando DaVinci Resolve Studio como herramienta
                  principal.
                </p>
              </div>
            </div>

            <div className="project_item">
              <div className="project_item-image">
                <img
                  src={contentImages(`./projects/02.jpg`)}
                  alt="Look cinematográfico"
                />
              </div>
              <div className="project_item_content">
                <h3 className="project_item_title">Look cinematográfico</h3>
                <p>
                  Correcciones cromáticas de vídeos de stock, con imágenes que
                  puedes ver en mi sección de portfolio.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="diference">
          <h2 className="diference_title">¿Qué me diferencia?</h2>
          <p className="diference_description">
            Soy alguien que vive este mundo con pasión. No dejo de aprender,
            experimentar y superarme. Estoy en constante evolución, siempre
            buscando nuevas formas de contar historias visuales con calidad
            cinematográfica. No me conformo con lo básico: busco impactar con
            cada imagen y cada frame.
          </p>
        </section>

        <section className="skills">
          <h3>Lo que sé</h3>
          <h2 className="skills_title">Programas que utilizo</h2>
          <div className="skills_content">
            <div className="skills_item">
              <img
                src={contentImages(`./logos/DaVinci_Resolve_17_logo.svg`)}
                alt="DaVinci icon"
              ></img>
              <p>Davinci Resolve Studio</p>
            </div>
            <div className="skills_item">
              <img
                src={contentImages(`./logos/maya.svg`)}
                alt="maya icon"
              ></img>
              <p>Autodesk Maya</p>
            </div>
            <div className="skills_item">
              <img
                src={contentImages(`./logos/Blender_logo_no_text.svg`)}
                alt="Blender icon"
              ></img>
              <p>Blender</p>
            </div>
            <div className="skills_item">
              <img
                src={contentImages(`./logos/Adobe_After_Effects_CC_icon.svg`)}
                alt="Adobe After Effects icon"
              ></img>
              <p>Adobe After Effects</p>
            </div>
            <div className="skills_item">
              <img
                src={contentImages(
                  `./logos/Adobe_Photoshop_Lightroom_CC_logo.svg`
                )}
                alt="Adobe Lightroom icon"
              ></img>
              <p>Adobe Lightroom</p>
            </div>
            <div className="skills_item">
              <img
                src={contentImages(`./logos/Adobe_Photoshop_CC_icon.svg`)}
                alt="Adobe Photoshop icon"
              ></img>
              <p>Adobe Photoshop</p>
            </div>
            <div className="skills_item">
              <img
                src={contentImages(`./logos/Adobe_Premiere_Pro_CC_icon.svg`)}
                alt="Adobe Premiere Pro icon"
              ></img>
              <p>Adobe Premiere Pro</p>
            </div>
          </div>
        </section>

        <section className="studies">
          <h3>Mi trayectoria de aprendizaje</h3>
          <h2 className="studies_title">Formación</h2>
          <div className="studies_content">
            <div className="studies_item">
              <p className="studies_item_title">
                Curso de Fundamentos de la Producción 3D
              </p>
              <p className="studies_item_center">
                <FaGraduationCap /> Animum Advanced School
              </p>
              <p className="studies_item_description">
                Modelado, UVs, texturizado, iluminación y composición.
              </p>
            </div>

            <div className="studies_item">
              <p className="studies_item_title">
                Curso de Postproducción de cine y vídeo
              </p>
              <p className="studies_item_center">
                <FaGraduationCap /> MasterD
              </p>
              <p className="studies_item_description">
                Edición profesional, color grading y workflow de cine.
              </p>
            </div>
          </div>
        </section>

        <section className="contact">
          <h3 className="contact_sub_title">Para más información</h3>
          <h2 className="contact_title">Contáctame</h2>
          <p className="contact_description">
            <NavLink
              className="contact_description"
              href="mailto:pitergp28@gmail.com"
              alt="enlace al correo electrónico"
            >
              <FaEnvelope />
              <span> pitergp28@gmail.com</span>
            </NavLink>
          </p>
          <p className="contact_description">
            <IoLocationSharp />
            <span> Benidorm, Alicante</span>
          </p>
        </section>

        <div className="myFooter">
          <NavLink
            className="footerItem"
            href="https://www.instagram.com/piter.gp/?utm_medium=copy_link"
            alt="enlace a instagram"
          >
            <FaInstagram />
            <span>instagram</span>
          </NavLink>
          <NavLink
            className="footerItem"
            href="https://www.tiktok.com/@photopiter"
            alt="enlace a tiktok"
          >
            <FaTiktok />
            <span>tiktok</span>
          </NavLink>
          <NavLink
            className="footerItem"
            href="https://www.youtube.com/@photopiterart/videos"
            alt="enlace a youtube"
          >
            <FaYoutube />
            <span>youtube</span>
          </NavLink>
          <NavLink
            className="footerItem"
            href="https://www.pinterest.es/Photopiter/"
            alt="enlace a pinterest"
          >
            <FaPinterest />
            <span>pinterest</span>
          </NavLink>
          <NavLink
            className="footerItem"
            href="https://www.linkedin.com/in/pedro-gavil%C3%A1n-pozo-4308a0277?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
            alt="enlace a linkedin"
          >
            <FaLinkedin />
            <span>linkedin</span>
          </NavLink>
          <NavLink
            className="footerItem"
            href="mailto:pitergp28@gmail.com"
            alt="enlace al correo electrónico"
          >
            <FaEnvelope />
            <span>pitergp28@gmail.com</span>
          </NavLink>
        </div>
      </div>
    </>
  );
};
